import React, { useEffect, useState } from 'react';
import Navbar from "../../components/Features/Navbar";
import hr from "./../../images/icons/hr.png";
import { Box, CircularProgress, Container } from '@mui/material';
import 'bootstrap/dist/css/bootstrap.min.css';
import Footer from '../../components/Home/Footer';
import { Fade } from 'react-awesome-reveal';
import StrapiRichText from '../../components/StrapiRichText';
import MentionsLegaleStatic from './MentionsLegaleStatic';
import { fetchMentionsLegalesFromStrapi } from '../../services/strapiMentionsLegales';
import { pickCmsTitle } from '../../utils/cmsContent';

const mentionsBodySx = {
  fontSize: '20px',
  lineHeight: 1.8,
  fontFamily: 'Montserrat',
  color: '#2f3036',
  fontWeight: 500,
  '& p': { marginTop: 0, marginBottom: '1rem' },
  '& p:last-child': { marginBottom: 0 },
  '& ul': { listStyleType: 'circle', marginLeft: '1.5rem', marginBottom: '2rem' },
  '& ol': { marginBottom: '2rem', paddingLeft: '1.25rem' },
  '& ol ul': { listStyleType: 'circle', marginTop: '0.5rem', marginBottom: '0.5rem' },
  '& li': { marginBottom: '0.25rem' },
  '& strong': { fontWeight: 700 },
  '& a': { color: '#1398aa' },
};

const DEFAULT_TITLE = 'Mentions Légales';

const MentionsLegales = () => {
  const [title, setTitle] = useState(DEFAULT_TITLE);
  const [strapiBody, setStrapiBody] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    document.title = `${title} | Tsahal Connection`;
  }, [title]);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const remote = await fetchMentionsLegalesFromStrapi();
        if (cancelled) return;
        setTitle(pickCmsTitle(remote?.title, DEFAULT_TITLE));
        const raw = remote?.body;
        const trimmed = raw != null && String(raw).trim() !== '' ? String(raw).trim() : null;
        setStrapiBody(trimmed);
      } catch {
        if (!cancelled) {
          setTitle(DEFAULT_TITLE);
          setStrapiBody(null);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  if (loading) {
    return (
      <div>
        <Navbar />
        <Box sx={{ display: 'flex', justifyContent: 'center', minHeight: '40vh', alignItems: 'center' }}>
          <CircularProgress sx={{ color: '#1398aa' }} />
        </Box>
        <Footer />
      </div>
    );
  }

  return (
    <div>
      <Navbar />
      <Fade triggerOnce>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', marginTop: '2rem' }}>
          <h1 style={{ fontFamily: 'Montserrat', fontWeight: '700', textAlign: 'center' }}>{title}</h1>
          <img src={hr} alt="" width="80" height="50" />
        </div>
        {strapiBody ? (
          <Container maxWidth="md" style={{ marginTop: '3rem', marginBottom: '4rem' }}>
            <StrapiRichText source={strapiBody} sx={mentionsBodySx} />
          </Container>
        ) : (
          <MentionsLegaleStatic />
        )}
        <Footer />
      </Fade>
    </div>
  );
};

export default MentionsLegales;
